const overviewProductTableHeaders = [
  {
    id: 'position',
    group: '#',
    canPrint: true
  },
  {
    id: 'codigo',
    group: 'Código',
    canPrint: true
  },
  {
    id: 'nome',
    group: 'Nome',
    canPrint: true
  },
  {
    id: 'quantidade',
    group: 'Quantidade',
    canPrint: true,
    align: 'right'
  },
  {
    id: 'valor',
    group: 'Valor',
    canPrint: true,
    align: 'right'
  }
]

export default overviewProductTableHeaders
